import { FunctionComponent, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { AppRole, DEFAULT_HOME, RouteKey } from "./permissions";
import { useRole } from "./useRole";

interface ProtectedRouteProps {
    /** Quem pode entrar — lista de roles permitidos.
     *  Use ESSA prop OU `requireKey`, nunca as duas. */
    allowedRoles?: AppRole[];

    /** Alternativa baseada na matriz: a chave de rota controla o acesso. */
    requireKey?: RouteKey;

    /** Para onde redirecionar se nao tiver permissao.
     *  Default: DEFAULT_HOME do role logado (ou "/" se nao logado). */
    redirectTo?: string;

    children: ReactNode;
}

/**
 * Envelopa um elemento de rota. Se o role nao tem permissao, redireciona.
 *
 * <Route path="/clients" element={
 *   <ProtectedRoute requireKey="clients"><Clients /></ProtectedRoute>
 * } />
 */
const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({
    allowedRoles,
    requireKey,
    redirectTo,
    children,
}) => {
    const { role, can } = useRole();

    const isAllowed = allowedRoles
        ? !!role && allowedRoles.includes(role)
        : requireKey
            ? can(requireKey)
            : !!role;

    if (isAllowed) return <>{children}</>;

    const fallback = redirectTo ?? (role ? DEFAULT_HOME[role] : "/");
    return <Navigate to={fallback} replace />;
};

export default ProtectedRoute;
